import { LoginService } from './../../../service/login.service';
import { InfoService } from './../../../service/info.service';
import { Component, OnInit } from '@angular/core';
import { ParametrosService } from 'src/app/service/parametros.service';


@Component({
  selector: 'app-horarios',
  templateUrl: './horarios.component.html',
  styleUrls: ['./horarios.component.scss']
})


export class HorariosComponent implements OnInit {
  msjError: any;
  session: any;

  filter = '';
  horario: any[] = [];

  constructor(private parametrosService: ParametrosService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
  }


  numParametro: number;
  error: boolean;
  loading: boolean;
  noResults: boolean;

  async ngOnInit() {
    this.numParametro = 26004;
    this.error = false;
    this.msjError = '';
    this.loading = false;

    await this.getHorarios();
  }

  async getHorarios() {
    this.loading = true;
    try {
      const res = await this.parametrosService.fetchParametros(this.numParametro);

      if (!res || !res.ok) {
        this.error = true;
        this.msjError = res?.message || 'Error al obtener datos';
        this.horario = [];
      } else {
        const data = (res as any).data || {};        
        if (Array.isArray(data.parametros) && data.parametros.length) {
            this.horario = data.parametros.filter(
            (p: any) => p.sIndicador02 === 'S' && p.sIndicador05 === 'S'
          );
          this.noResults = this.horario.length === 0;
        } else {          
          this.horario = data || [];
          this.noResults = true;
        }
        this.error = false;
      }
    } catch (err) {
      console.error('Error getHorario', err);
      this.error = true;
      this.msjError = 'Error inesperado';
      this.horario = [];
    } finally {
      this.loading = false;
    }
  }
}